<template>
  <modal :visible="visible" @on-close="onClose()">
    <template v-slot:header>
         <h6 class="userName">{{ product.sku }} - {{ product.name }}</h6>
    </template>
    <template v-slot:body>
      <div style="background-color:--main-bg-color;" class="nav-pills nav-fill">
        <div class="head-info">
          <th>
            <h6 class="userName">{{ product.sku }} - {{ product.name }}</h6>
            <p> {{ parseFloat(product.codeOfUnit) }} - {{ product.nameOfUnit }} - ({{ product.unitOfSell }}) </p>
            <p>  {{ $t("products.weight") }} -  {{ parseFloat(product.url)}} {{"kg" }}</p>
          </th>
        </div>
      </div>
      <div>
        {{ product.userText }}
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn" @click="onClose()">
        {{ $t("buttons.close") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { currencyMixin } from "../mixins";
import Modal from "./Modal";
export default {
  name: "ProductInfoModal",
  components: {
    Modal,
  },
  mixins: [currencyMixin],
  props: {
    product: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    visible: Boolean,
  },
  methods: {
    onClose() {
      this.$emit("on-close");
    },
  },
};
</script>
